import { DetailPageUrlType, ListRowType } from 'types/ListTypes';

/*
 * detailPageUrl.ts
 * Resolves the detail page path a list row links to, used both by
 * the row click handler and by the row links which let the browser
 * open the page in a new tab.
 */

// Returns the detail page path of a row, or null when the list has no detail page
export const resolveDetailPageUrl = (detailPageUrl: DetailPageUrlType | undefined, row: ListRowType): string | null => {
    let url: string | undefined;

    // A fixed string is the base path of the detail page
    if (typeof detailPageUrl === 'string') {
        url = detailPageUrl;
    }

    // An object builds the base path from a field of the row data
    else if (detailPageUrl) {
        url = detailPageUrl.baseUrl;
        if (detailPageUrl.urlSuffixApiField) {

            // Use the value of the given api field, or the fallback when that value is missing
            const suffix = row[detailPageUrl.urlSuffixApiField] ?? detailPageUrl.urlSuffixFallback;
            url = `${url}/${suffix}`;
        }
    }

    // The page path ends with the id of the row
    if (!url || !row.id) {
        return null;
    }
    return `/${url}/${row.id}`;
};
